import React, { useState, useCallback, useEffect } from "react";
import { TabPane } from "reactstrap";
import { Resultset, WebRow } from "components/response";
import { useSearchWeb } from "hooks";

const WebTab = ({ q, tabId, className }) => {
  const [detail, setDetail] = useState(null);
  const [result, search] = useSearchWeb();
  const execute = useCallback(() => {
    search(q);
  }, [q, search]);
  const onRowClick = useCallback((detail) => {
    detail && detail.url && window.open(detail.url[0], "_blank");
    setDetail(detail);
  }, []);
  useEffect(() => {
    execute();
  }, [execute]);
  return (
    <TabPane tabId={tabId} className={className}>
      <Resultset
        setDetail={onRowClick}
        status={result.status}
        result={result}
        execute={execute}
        detailId={detail != null ? detail.id : -1}
        RowComponent={WebRow}
      />
    </TabPane>
  );
};

export { WebTab };
